import client from '@/api/client.js';
import store from "@/store";

export default {
    methods: {
        async getEmailTemplates() {
            const meta = { clientApiMethod: 'getEmailTemplates' };
            const url = store.state.apiRouteRoot + `Email/Templates`;
            const response = await client().get(url, { meta });
            return response?.data || [];
        },

        async getEmailTemplateConfig(configClass) {
            const meta = { clientApiMethod: 'getEmailTemplateConfig', input: { configClass } };
            const url = store.state.apiRouteRoot + `Email/TemplateConfig/${encodeURIComponent(configClass)}`;
            const response = await client().get(url, { meta });
            return response?.data;
        },

        async updateEmailTemplateConfig(configClass, payload) {
            const meta = { clientApiMethod: 'updateEmailTemplateConfig', input: { configClass, payload } };
            const url = store.state.apiRouteRoot + `Email/TemplateConfig/${encodeURIComponent(configClass)}`;
            const response = await client().put(url, payload, { meta });
            return response?.data;
        },
    }
};